import { makeStyles } from '@material-ui/core'

/**
 * CKEditor component overridden styles
 */
export const useContentEditorStyles = makeStyles(() => ({
    // Define the blinking caret animation at root level for Material-UI
    '@keyframes caretBlink': {
        '0%, 49%': { opacity: 1 },
        '50%, 100%': { opacity: 0 },
    },
    editorSelectionHandle: {
        // Hide drag/drop handle for tables
        '& .ck.ck-widget__selection-handle': {
            display: 'none',
        },
    },
    editorContent: {
        // Remove spaces before and after paragraphs
        '& .ck.ck-editor__editable_inline > *:first-child': {
            marginTop: 0,
        },
        '& .ck.ck-editor__editable_inline > *:last-child': {
            marginBottom: 0,
        },
    },
    editor: {
        display: 'inline-flex',
        whiteSpace: 'normal',
        verticalAlign: 'baseline',
        alignItems: 'baseline',
        maxWidth: 'none',
        // Base editor styles
        '& .ck.ck-editor__editable': {
            border: 'none',
            padding: 0,
            margin: 0,
            overflow: 'visible',
            background: 'transparent !important',
            minHeight: '1.2em', // Slightly increased for better caret visibility
            minWidth: '10px', // Increased to ensure clickable area
        },
        // Empty paragraph minimum height
        '& .ck.ck-editor__editable p:empty': {
            minHeight: '1.2em',
            position: 'relative',
            // Firefox: Prevent extra vertical spacing
            '@supports (-moz-appearance: none)': {
                minHeight: '1.2em',
            },
        },
        // Visual caret for empty content when focused - centered between pills
        // Covers both p:first-child and p:empty cases
        '& .ck.ck-editor__editable.ck-empty-content.ck-focused p:first-child, & .ck.ck-editor__editable.ck-empty-content.ck-focused p:empty': {
            position: 'relative',
            minHeight: '1.2em',
            textAlign: 'center',
            // Firefox: Match rendering behavior with Chrome
            '@supports (-moz-appearance: none)': {
                minHeight: '1.2em',
                display: 'inline-block',
            },
            '&::after': {
                content: '""',
                position: 'absolute',
                left: '50%',
                transform: 'translateX(-50%)',
                top: '0',
                width: '1px',
                height: '100%',
                backgroundColor: 'black',
                animation: '$caretBlink 1s steps(1, end) infinite',
                pointerEvents: 'none',
            },
        },
        // Focused editor styles
        '& .ck.ck-editor__editable.ck-focused:not(.ck-editor__nested-editable)': {
            border: 'none',
            boxShadow: 'none',
            outline: 'none',
            padding: 0,
            margin: 0,
            borderRadius: '4px',
        },
        // Hide toolbar
        '& .ck.ck-sticky-panel': {
            display: 'none',
        },
        '& .ck.ck-sticky-panel__content': {
            display: 'none !important',
        },
    },
}))
